import React, { FC, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppDispatch } from '../../../redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { getAllTransaction, selectAllTransc, selectTranscError, selectTranscStatus } from '../../../redux/Slices/TransactionSlice'
import { selectGameId } from '../../../redux/Slices/JoinGameSlice'
import RefreshButton from '../../atoms/RefreshButton/RefreshButton'
import TransactionContainer from '../../molecules/TransactionContainer/TransactionContainer';
import OutsideClickHandler from 'react-outside-click-handler'
import HelpContainer from '../../molecules/HelpContainer/HelpContainer'
import { IoMdHelpCircleOutline, IoMdInformationCircleOutline } from "react-icons/io";
import sendFirebaseEvent from '../../../app/firebase/sendFirebaseEvent'
import { image } from '../../../app/utils/common/image'

interface TransactionScreenProps {
    secondsLeft: number | null,
    helpShow: boolean,
    setHelpShow: React.Dispatch<React.SetStateAction<boolean>>,
    handleClose: VoidFunction,
}


const TransactionScreen: FC<TransactionScreenProps> = (props) => {
    const { secondsLeft, helpShow, setHelpShow, handleClose } = props
    const [loading, setLoading] = useState<boolean>(false);

    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();
    const transaction = useSelector(selectAllTransc);
    const transactionStatus = useSelector(selectTranscStatus);
    const transactionError = useSelector(selectTranscError);
    const gameId = useSelector(selectGameId);

    useEffect(() => {
        dispatch(getAllTransaction(gameId)); // Dispatch Get stockPrices action
    }, [dispatch])

    // Stock Prices status loading state
    useEffect(() => {
        if (transactionStatus === 'loading') {
            setLoading(true);
        } else if (transactionStatus === 'succeeded') {
            setLoading(false);
        } else if (transactionStatus === 'failed') {
            setLoading(false);
            if (transactionError?.error?.message === 'Game already completed.') {
                navigate('/profile')
            }
        }
    }, [transactionStatus]);

    // Handle Refresh Button to reload transc data
    const handleRefreshButton = () => {
        setLoading(true);
        dispatch(getAllTransaction(gameId))
            .unwrap()
            .then(() => {
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }

    return (
        <div className='padding-bottom'>
            <div className='account-heading'>
                {/* <BackButton onClick={handleBackButton} buttonHeading='Transaction History' className='colorHeading-bckbtn transc-back font-bagel' /> */}
                <div className='purchase-btn-container'>
                    <img src={image.PURCHASE} className='purchase-btn' onClick={() => { window.open('https://joyjuncture.com', "__blank") }} />
                </div>
                <RefreshButton onClick={handleRefreshButton} />
            </div>

            <div className='timer-heading'>
                <div className='colorHeading-bckbtn portfolio-heading portfolio-text'>
                    <div className='font-bagel'>Trade History </div>
                    <div className="get-help-addOn-hover" style={{ paddingTop: "7px", marginTop: "0px", paddingLeft: "3px" }}>
                        <div className="help-image-logo" > <IoMdInformationCircleOutline cursor='pointer' /></div>
                        <div className="get-help-add-on-hover-history">View your recent transactions to track both your trades and broker updates</div>
                    </div>
                </div>
                {secondsLeft && secondsLeft > 0 && <div className='seconds-left'>{secondsLeft} Sec</div>}
            </div>
            {/* <div className='colorHeading-bckbtn font-bagel'>Transaction History</div> */}
            <div className='flex stocks-container'>
                <div className='flex stockContainer' style={{ gap: "20px", position: "relative" }}>
                    <div className='help-btn help-trade-btn' style={{}} onClick={() => { setHelpShow(!helpShow); sendFirebaseEvent('help_button', 'user_action', 'help_button', "Help Button Clicked") }}>
                        <IoMdHelpCircleOutline color='#fff' size={28} cursor={'pointer'} />
                    </div>
                    {helpShow && <OutsideClickHandler onOutsideClick={handleClose}>
                        <HelpContainer setHelpShow={setHelpShow} />
                    </OutsideClickHandler>}
                    <div className='account-border'>
                        <div className='account-container flex transc-container'>
                            {transaction?.length !== 0 ?
                                <TransactionContainer transaction={transaction} loading={loading} /> :
                                <div style={{ height: "585px" }} className='empty-container'>Oops! No transaction found</div>}
                        </div>
                    </div>
                </div>
                {/* <BottomSheet /> */}
            </div>
        </div>
    )
}

export default TransactionScreen